module.exports = __webpack_public_path__ + "static/media/about.16d23345.png";